import { render } from "./ShoppingCart.vue?vue&type=template&id=195c007b&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=195c007b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-195c007b"

export default script